import { FC } from "react";
import { FormInput } from "shared/ui";
import type { NameField } from "../model/useNameField";
import { NAME_MAX_LENGTH } from "../model/validateUserName";

interface Props {
  field: NameField;
  placeholder: string;
  autoComplete: string;
  disabled: boolean;
  autoFocus?: boolean;
}

export const NameInput: FC<Props> = ({ field, ...inputProps }) => (
  <FormInput
    {...inputProps}
    value={field.value}
    error={field.error}
    maxLength={NAME_MAX_LENGTH}
    onValueChange={field.onChange}
    onBlur={field.touch}
  />
);
